<template>
  <!-- 优秀班主任 -->
  <div class="home-teacher">
    <div class="g-box">
      <div class="title">
        <div class="zh"><span class="text">优秀班主任</span></div>
        <!-- <div class="en">EXCELLENT CLASS TEACHER</div> -->
      </div>
      <div class="content">
        <div class="item" v-for="item in newsList" :key="item.id">
          <div class="item-le">
            <div class="avatar">
              <img :src="item.image" alt="" class="img" />
            </div>
            <div class="name">{{ item.title }}</div>
            <div class="time">{{ item.subtitle }}</div>
          </div>
          <div class="item-ri">
            <div class="tip"></div>
            <div class="assess">
              {{ item.tips }}
            </div>
            <div class="line"></div>
            <div class="intro">
              {{ item.content }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pageMain_mx from "../../../mixins/pageMain_mx";

export default {
  mixins: [pageMain_mx],
  data() {
    return {
      bannerList: [],
      newsList: []
    };
  },
  components: {},
  async mounted() {
    const menuId3 = this.getMenuId("教学特色-特色展示-班主任团队");
    if (menuId3) {
      const data = await this.getMenuList({
        pageNum: 1,
        pageSize: 1000,
        menuId: menuId3
      });
      this.newsList = data;
    }
  },
  methods: {}
};
</script>
<style lang="less">
//优秀班主任
.home-teacher {
  margin-top: 90px;
  .title {
    text-align: center;
    .zh {
      font-size: 32px;
      font-weight: 600;
      color: #1465f5;
      .text {
        position: relative;
      }
      .text::after {
        position: absolute;
        content: "";
        left: 32px;
        bottom: -16px;
        width: 64px;
        height: 1px;
        background-color: #a8aab8;
      }
    }

    .en {
      padding-top: 36px;
      font-size: 14px;
      font-weight: 500;
      color: #656878;
    }
  }
  .content {
    margin-top: 90px;
    display: flex;
    flex-wrap: wrap;
    .item {
      margin-bottom: 70px;
      padding: 30px;
      width: 580px;
      height: 230px;
      display: flex;
      box-sizing: border-box;
      background-image: url("../../../assets/img/teacher-bg.png");
      background-repeat: no-repeat;
      cursor: pointer;
      &-le {
        position: relative;
        top: -60px;
        .avatar {
          width: 120px;
          height: 150px;
          .img {
            width: 120px;
            height: 150px;
            border-radius: 8px;
          }
        }
        .name {
          padding-top: 20px;
          font-size: 18px;
          font-weight: 600;
          color: #202930;
        }
        .time {
          padding-top: 10px;
          color: #202930;
        }
      }
      &-ri {
        margin-left: 30px;
        .tip {
          width: 24px;
          height: 24px;
          background-image: url("../../../assets/img/icon1.png");
        }
        .assess {
          padding-top: 4px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          white-space: normal;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .line {
          margin-top: 14px;
          width: 32px;
          height: 2px;
          background: #1465f5;
        }
        .intro {
          padding-top: 20px;
          font-size: 12px;
          color: #202930;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
          white-space: normal;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
    .item:hover {
      background-image: url("../../../assets/img/teacher-bg2.png");
      .item-le {
        .name {
          color: #fff;
        }
        .time {
          color: #fff;
        }
      }
      .item-ri {
        .tip {
          background-image: url("../../../assets/img/icon2.png");
        }
        .assess {
          color: #fff;
        }
        .line {
          background: #fff;
        }
        .intro {
          color: #fff;
        }
      }
    }
  }
}
</style>
